import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import Checkout from "./Checkout";
import Checkout1xbet from "./Checkout1xbet";

function CheckoutIndex() {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? <Checkout1xbet /> : <Checkout />;
}

export default CheckoutIndex;
